import { styled } from '@mui/material';
import { CoreDialog, CoreDialogTitle } from '@youscience/core';

export const sxStyles = {
  contentBody: {
    padding: '0 1rem 2.5rem',
  },
};

export const StyledDialog = styled(CoreDialog)(() => ({
  '.MuiPaper-root': {
    maxWidth: '576px',
    width: '100%',
    borderRadius: '12px',
  },
}));

export const StyledDialogTitle = styled(CoreDialogTitle)(({ theme }) => ({
  ...theme.typography.h4,
  padding: '1rem',
  textAlign: 'center',

  [theme.breakpoints.up('sm')]: {
    padding: '2.5rem 2rem 1rem',
  },
}));
